import React from "react";
import { useDispatch } from "react-redux";
import { toastService } from "../../utils/toastify";
import { deleteFAQ, getFAQ } from "../../features/slices/faqManagement";
import Modal from "../Modal";
const DeleteFaqModal = ({ setUpdateState, faqData }) => {
  const dispatch = useDispatch();
  const hanldeClose = () => {
    setUpdateState((prev) => ({
      ...prev,
      showDeleteFaq: false,
    }));
  };
  const handleDelete = () => {
    dispatch(deleteFAQ({ faqId: faqData?._id })).then((res) => {
      if (res?.payload?.code === 200) {
        toastService.success("Faq deleted successfully");
        dispatch(getFAQ());
        hanldeClose();
      } else {
        toastService.error(res?.payload?.message);
      }
    });
  };
  return (
    <Modal>
      <div className="modal-body">
        <div className="Decline">
          <a className="CloseModal" onClick={hanldeClose}>
            ×
          </a>
          <h3>Delete</h3>
          <p>Are you sure you want to delete this FAQ</p>
          <h4>
            <a onClick={hanldeClose}>no</a>
            <a onClick={handleDelete}>Yes</a>
          </h4>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteFaqModal;
